{
  "checkoutAddress": {
    "shippingAddress": "Shipping Address",
    "selectYourShippingAddress": "Select your Shipping Address",
    "defaultShippingAddress": "Default Shipping Address",
    "verifyYourAddress": "Verify your address",
    "ensureAccuracySuggestChange": "To ensure delivery accuracy, we suggest the change selected below.",
    "chooseAddressToUse": "Please choose which address you would like to use:",
    "suggestedAddress": "Suggested address",
    "enteredAddress": "Entered address",
    "addNewAddress": "Add New Address",
    "shipToThisAddress": "Ship to this address",
    "editAddress": "Edit address",
    "saveAddress": "Save address"
  },
  "checkoutOrderConfirmation": {
    "confirmationOfOrder": "Confirmation of Order:",
    "thankYou": "Thank you for your order!",
    "invoiceHasBeenSentByEmail": "An invoice has been sent by email. You should receive it soon.",
    "orderItems": "Order Items",
    "orderPlacedSuccessfully": "Order placed successfully",
    "createAccount": "Create an account?",
    "createAccountForNext": "Create an account for <{{email}}> for a faster checkout on your next visit.",
    "replenishmentNumber": "Replenishment #",
    "placedOn": "Placed on",
    "status": "Status",
    "active": "Active",
    "cancelled": "Cancelled",
    "frequency": "Frequency",
    "nextOrderDate": "Next order date",
    "orderNumber": "Order Number"
  },
  "checkoutReview": {
    "review": "Review",
    "orderItems": "Order Items",
    "autoReplenishOrder": "Auto Replenish Order",
    "confirmThatRead": "I am confirming that I have read and agreed with the",
    "placeOrder": "Place Order",
    "scheduleReplenishmentOrder": "Schedule Replenishment Order",
    "orderType_PLACE_ORDER": "None (one time order only)",
    "orderType_SCHEDULE_REPLENISHMENT_ORDER": "Replenish Order",
    "termsAndConditions": "Terms & Conditions",
    "editShippingAddress": "Edit shipping address",
    "poNumber": "Purchase Order Number",
    "every": "Every",
    "startOn": "Start on",
    "dayOfMonth": "On day",
    "repeatOnDays": "Repeat on the following days",
    "recurrencePeriodType_DAILY": "Day(s)",
    "recurrencePeriodType_WEEKLY": "Week(s)",
    "recurrencePeriodType_MONTHLY": "Month"
  },
  "checkoutShipping": {
    "shippingMethod": "Shipping Method",
    "standardDelivery": "Standard Delivery",
    "premiumDelivery": "Premium Delivery"
  },
  "checkout": {
    "backToCart": "Back to cart",
    "invalid": {
      "accountType": "Your account does not allow you to checkout here."
    }
  },
  "checkoutPO": {
    "noPoNumber": "None",
    "poNumber": "Purchase order number (optional)",
    "costCenter": "Cost Center",
    "placeholder": "Enter P.O",
    "availableLabel": "Shipping addresses available to you depend on the cost center's unit"
  },
  "checkoutProgress": {
    "methodOfPayment": "Method of Payment",
    "shippingAddress": "Shipping Address",
    "deliveryMode": "Delivery Mode",
    "paymentDetails": "Payment Details",
    "reviewOrder": "Review Order"
  }
}